import { iconsSet as icons } from "../assets/icons/icons.js";

const initialize = () => {
  return icons;
};

export default initialize;
